import { Component, input } from '@angular/core';

@Component({
  selector: 'app-plus-icon',
  imports: [],
  templateUrl: './plus-icon.html',
  styleUrl: './plus-icon.scss',
})
export class PlusIcon {
  width = input<string | number>(16);
  height = input<string | number>(16);
  strokeWidth = input<string | number>(2);
}
